export default __webpack_public_path__ + "static/topic20-d539d044b0424eecb94d540c87bf5090.png";